<template>
    <Header></Header>
    <Left></Left>
    <section class="container">
        <div class="blue_box _full">
            <div class="box_tit _flex">
                <h2>캠페인·이벤트</h2>
                <div class="info_box">
                    <div>
                        총 게시물
                        <span class="col_blue">{{ CommonUtils.numberFormat(state.totalLength) }}개</span>
                    </div>
                </div>
            </div>
            <div class="sch_condition_wrap">
                <div class="left">
                    <div class="select_date_wrap">
                        <div class="select_date">
                            <input type="date" @keydown.enter="searchDate" name="" id="" v-model="form_state.startDate" @change="getList" />
                        </div>
                        <div class="select_date">
                            <input
                                style="margin-left: 5px"
                                type="date"
                                @keydown.enter="searchDate"
                                name=""
                                id=""
                                v-model="form_state.endDate"
                                @change="getList"
                            />
                        </div>
                    </div>
                    <div class="search_wrap">
                        <input
                            type="text"
                            v-model="state.searchText"
                            @keyup.enter="
                                state.page = 1;
                                getList();
                            "
                            placeholder="제목을 입력하세요."
                        />
                        <button
                            type="button"
                            class="search_btn icon_wrap"
                            @click="
                                state.page = 1;
                                getList();
                            "
                        >
                            <img src="img/search_btn.png" alt="" />
                        </button>
                    </div>
                </div>
                <div class="right">
                    <button type="button" class="default_btn _blue" @click="addEvent">등록</button>
                    <button type="button" class="default_btn _gray" @click="isDelete">삭제</button>
                    <button type="button"><img src="img/excel_icon.png" @click="downloadFile" alt=" 엑셀 다운로드" /></button>
                </div>
            </div>

            <div class="common_table custom_scroll">
                <table>
                    <colgroup>
                        <col style="width: 40px" />
                        <col style="width: 70px" />
                        <col style="width: 150px" />
                        <col style="width: 100px" />
                        <!-- <col style="width: 70px" />
                        <col style="width: 70px" /> -->
                        <col style="width: 100px" />
                        <col style="width: 120px" />
                        <col style="width: 100px" />
                        <col style="width: 170px" />
                        <col style="width: 100px" />
                        <col style="width: 100px" />
                        <col style="width: 100px" />
                        <col style="width: 90px" />
                        <col style="width: 70px" />
                        <col style="width: 70px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th class="checkbox_wrap cnt p_5 checkbox_wrap2">
                                <input type="checkbox" v-model="state.checkAll" @change="toggleAll()" />
                            </th>
                            <th>번호</th>
                            <th>제목</th>
                            <th>모집인원</th>
                            <!-- <th>신청인원</th> -->
                            <!-- <th>선발인원</th> -->
                            <th>조회수</th>
                            <th>작성자</th>
                            <th>상태</th>
                            <th>작성일</th>
                            <th>모집 시작일</th>
                            <th>모집 종료일</th>
                            <th>신청 종료일</th>
                            <th>신청서 양식</th>
                            <th>현황</th>
                            <th>수정</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="state.list.length > 0">
                            <tr v-for="(item, idx) in state.list" :key="item.idx">
                                <td class="checkbox_wrap cnt p_5 checkbox_wrap2">
                                    <label :for="'chk_' + item.idx" @click.stop>
                                        <input type="checkbox" :id="'chk_' + item.idx" v-model="state.checkedList" :value="item.idx" @click.stop />
                                    </label>
                                </td>
                                <td class="list_num">{{ (state.page - 1) * state.size + (idx + 1) }}</td>
                                <td class="ellipsis_1">
                                    <button type="button" class="tb_img img_wrap" @click="viewImage(item.thumbnail)" v-if="item.thumbnail">
                                        <img :src="item.thumbnail ? item.thumbnail : 'img/login_bg.png'" alt="" />
                                    </button>
                                    <span class="underline">
                                        <a :href="state.userSiteUrl + '/#/eventView/' + +item.idx" target="_blank">{{ item.title }}</a>
                                    </span>
                                </td>
                                <td class="cnt">{{ !item.cntApply ? 0 : CommonUtils.numberFormat(item.cntApply) }}</td>
                                <!-- <td class="cnt">{{ !item.applyCnt ? 0 : CommonUtils.numberFormat(item.applyCnt) }}</td> -->
                                <!-- <td class="cnt">{{ !item.pickCnt ? 0 : CommonUtils.numberFormat(item.pickCnt) }}</td> -->
                                <td class="cnt">{{ !item.viewCnt ? 0 : CommonUtils.numberFormat(item.viewCnt) }}</td>
                                <td>{{ item.writer }}</td>
                                <td class="cnt">{{ strState(item.applyState) }}</td>
                                <td class="cnt">{{ CommonUtils.dateFormat(new Date(item.createDate), ".", true) }}</td>
                                <td class="cnt">
                                    {{
                                        item.recruitStartDate != null && item.type === 2
                                            ? CommonUtils.dateFormatYY(new Date(item.recruitStartDate), ".")
                                            : ""
                                    }}
                                </td>
                                <td class="cnt">
                                    {{
                                        item.recruitEndDate != null && item.type === 2
                                            ? CommonUtils.dateFormatYY(new Date(item.recruitEndDate), ".")
                                            : ""
                                    }}
                                </td>
                                <td class="cnt">{{ item.applyDate ? CommonUtils.dateFormatYYMMDD(new Date(item.applyDate), ".") : "" }}</td>
                                <td class="cnt p_5">
                                    <!-- 신청 form 작성/수정 -->
                                    <button
                                        v-if="new Date(item.recruitStartDate) > new Date()"
                                        type="button"
                                        class="table_btn _blue"
                                        @click="showForm(item.idx)"
                                    >
                                        보기
                                    </button>
                                </td>
                                <td class="cnt p_5">
                                    <!-- <template v-if="item.applyState === 1"> -->
                                    <button
                                        type="button"
                                        v-if="new Date(item.recruitStartDate) < new Date()"
                                        class="table_btn _blue"
                                        @click="eventStateModal(item.idx)"
                                    >
                                        보기
                                    </button>
                                    <!-- 신청 현황 -->
                                    <!-- </template> -->
                                </td>
                                <td class="cnt p_5">
                                    <button type="button" class="table_btn _blue" @click="modify(item.type, item.idx)">수정</button>
                                </td>
                            </tr>
                        </template>
                        <tr v-else>
                            <td colspan="10">
                                <div class="tb_subject" style="text-align: center; width: 100%">데이터가 없습니다.</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <PageBtn
                v-if="state.list.length !== 0"
                :currentPage="state.page"
                :totalLength="state.totalLength"
                :perPage="state.size"
                @onPaging="handlePageChange"
            ></PageBtn>
        </div>
    </section>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>

    <EventStateModal
        v-if="state.isShowApplyModal"
        :idx="state.itemIdx"
        @close="state.isShowApplyModal = false"
        @saveForMemoCntWin="saveForMemoCntWin"
        @exportExcelForEventApply="exportExcelForEventApply"
    ></EventStateModal>

    <EventModal
        v-if="state.isEventShowModal"
        :data="state.eventInfo"
        @close="state.isEventShowModal = false"
        @callback="
            state.isEventShowModal = false;
            getList();
        "
    ></EventModal>

    <FormListModal
        v-if="state.isShowForm"
        :idx="state.idx"
        type="event"
        @close="state.isShowForm = false"
        @callback="
            state.isShowForm = false;
            getList();
        "
    ></FormListModal>
</template>
<script lang="ts" config>
    import {
        userStore,
        globalStore,
        popupStore,
        reactive,
        watch,
        apiService,
        onMounted,
        router,
        Header,
        Left,
        ModalDefault,
        ModalPopup,
        types,
        onBeforeUnmount,
        getMessageByCode,
        EventStateModal,
        CommonUtils,
        PageBtn,
        EventModal,
        FormListModal,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { Header, Left, ModalDefault, PageBtn, EventModal, EventStateModal, FormListModal },
        setup() {
            const global = globalStore();
            const user = userStore();
            const popup = popupStore();

            const state = reactive({
                idx: 0 as number,
                eventIdx: 139,
                list: [] as Array<any>,

                page: 1 as number,
                size: 20 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,

                searchType: "" as string,
                searchText: "" as string,
                startDate: "" as string,
                endDate: "" as string,

                isShowSearchType: false,
                isEventShowModal: false as boolean,
                isShowApplyModal: false as boolean,
                itemIdx: 0 as number,

                eventInfo: {} as any,

                checkAll: false as boolean,
                checkedList: [] as Array<number>,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                isShowForm: false as boolean,

                detailTxt: "전체" as string,
                state: "99" as string,

                userSiteUrl: process.env.VUE_APP_USER_FRONT_ADDRESS,
            });

            const form_state = reactive({
                startDate: "" as string,
                endDate: "" as string,
            });

            const imgError = (e: Event) => {
                const target = e.target as HTMLImageElement;
                if (target) {
                    target.src = require("@/assets/no_img.png");
                }
            };

            onMounted(() => {
                getList();
            });

            onBeforeUnmount(() => {});

            watch(
                () => state.searchText,
                (newVal, oldVal) => {
                    if (oldVal && newVal === "") {
                        getList();
                    }
                },
            );

            watch(
                () => [state.checkedList, state.list],
                () => {
                    state.checkAll = state.checkedList.length > 0 && state.checkedList.length === state.list.length;
                },
            );

            const handlePageChange = (page: number) => {
                state.page = page;
                getList();
            };

            const closeModal = () => {
                state.isShowModal = false;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                    deleteCheckList();
                }
            };

            const isDelete = () => {
                if (state.checkedList && state.checkedList.length > 0) {
                    state.modalTab = 5;
                    state.modalTitle = "알림";
                    state.modalContent = "정말 삭제하시겠습니까?";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "선택된 게시글이 없습니다.";
                    state.isShowModal = true;
                }
            };

            const deleteCheckList = async () => {
                if (state.checkedList && state.checkedList.length > 0) {
                    const param: types.ReqIdxList = {
                        idxList: state.checkedList.join(","),
                    };
                    const res = await apiService.board.remove(param);

                    if (res.returnCode === 0) {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "삭제가 완료되었습니다.";
                        state.isShowModal = true;

                        getList();
                        state.checkedList = [];
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "선택된 게시글이 없습니다.";
                    state.isShowModal = true;
                }
            };

            const searchDate = async () => {
                if (form_state.startDate && form_state.endDate && form_state.endDate < form_state.startDate) {
                    form_state.endDate = "";
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "날짜를 올바르게 선택해주세요.";
                    state.isShowModal = true;
                    return;
                }
                state.startDate = form_state.startDate;
                state.endDate = form_state.endDate;
                state.page = 1;
                getList();
            };

            const getList = async () => {
                state.checkedList = [];
                const param: types.ReqBoardListForAdmin = {
                    page: state.page,
                    size: state.size,
                    searchType: state.searchType,
                    searchText: state.searchText,
                    type: 2,
                    title: "",
                    startDate: state.startDate,
                    endDate: state.endDate,
                };

                const res = await apiService.board.list(param);

                if (res.returnCode === 0) {
                    state.list = res.list.data;
                    state.totalPage = res.list.totalPages;
                    state.totalLength = res.list.recordsTotal;
                } else {
                    state.list = [];
                    state.totalPage = 0;
                    state.totalLength = 0;
                }
            };

            const downloadFile = async () => {
                try {
                    const param: types.ReqNewsForExcel = {
                        searchText: state.searchText,
                        startDate: state.startDate,
                        endDate: state.endDate,
                        idxList: String(state.checkedList),
                    };

                    let res = await apiService.board.exportExcelForEvent(param);

                    if (res && res.data) {
                        const blob = new Blob([res.data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });
                        const disposition = res.headers["content-disposition"];
                        let fileName = "download.xlsx";
                        if (disposition) {
                            const match = disposition.match(/filename="?(.+)"?/);
                            if (match && match[1]) {
                                fileName = decodeURIComponent(match[1]);
                            }
                        }
                        const a = document.createElement("a");
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("파일 다운로드 실패:", err);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "파일 다운로드 실패";
                    state.isShowModal = true;
                }
            };

            const toggleAll = () => {
                if (state.checkAll) {
                    state.checkedList = state.list.map((item) => item.idx);
                } else {
                    state.checkedList = [];
                }
            };

            const modify = async (type: number, idx: number) => {
                const res = await apiService.board.detail(type, idx);

                if (res.returnCode === 0) {
                    state.eventInfo = res.data;

                    state.isEventShowModal = true;
                }
            };

            const search_type_list = [
                { id: "all", key: "99", value: "전체" },
                { id: "1", key: "1", value: "진행 전" },
                { id: "2", key: "2", value: "진행 중" },
                { id: "3", key: "3", value: "진행 완료" },
            ];

            const strState = (val: number) => {
                switch (val) {
                    case 1:
                        return "완료";
                    case 0:
                        return "미완료";
                }
            };

            const viewImage = async (param: string) => {
                state.modalTab = 11;
                state.modalTitle = "알림";
                state.modalContent = param;
                state.isShowModal = true;
            };

            const addEvent = () => {
                state.eventInfo = null;
                state.isEventShowModal = true;
            };

            const eventStateModal = async (idx: number) => {
                state.itemIdx = idx;
                state.isShowApplyModal = true;
            };

            const saveForMemoCntWin = async (info: types.ResBoardVOForApi) => {
                const param: types.ReqBoardForEventForModify = {
                    idx: info.idx,
                    cntWin: info.cntWin,
                    memo: info.memo,
                    title: null,
                    content: null,
                    cntApply: null,
                    recruitmentStartDate: null,
                    recruitmentEndDate: null,
                    urlCallback: null,
                    urlForEvent: null,
                    endDate: null,
                    term: null,
                    file: null,
                };
                const res = await apiService.board.modifyForEvent(state.itemIdx, param);

                if (res.returnCode === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = "수정이 완료되었습니다.";
                    state.isShowModal = true;

                    state.isShowApplyModal = false;
                } else {
                    console.error(res.description);
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const exportExcelForEventApply = async (type: number, idx: number) => {
                try {
                    let res;
                    if (idx !== state.eventIdx) res = await apiService.board.exportExcelForEventApply(type, idx);
                    else res = await apiService.campainEvent.exportExcel(idx);

                    if (res && res.data) {
                        const blob = new Blob([res.data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });
                        const disposition = res.headers["content-disposition"];
                        let fileName = "download.xlsx";
                        if (disposition) {
                            const match = disposition.match(/filename="?(.+)"?/);
                            if (match && match[1]) {
                                fileName = decodeURIComponent(match[1]);
                            }
                        }
                        const a = document.createElement("a");
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("파일 다운로드 실패:", err);
                }
            };

            const showForm = (idx: number) => {
                state.isShowForm = true;
                state.idx = idx;
            };

            return {
                state,
                user,
                router,
                closeModal,
                callBackModal,
                imgError,
                types,
                CommonUtils,
                global,
                popup,
                form_state,
                searchDate,
                handlePageChange,
                search_type_list,
                strState,
                getList,
                isDelete,
                downloadFile,
                toggleAll,
                modify,
                viewImage,
                eventStateModal,
                exportExcelForEventApply,
                addEvent,
                saveForMemoCntWin,
                showForm,
            };
        },
    };
</script>

<style scoped>
    .underline {
        text-decoration: underline;
        text-underline-offset: 5px;
    }
</style>
